import { extend } from 'flarum/extend';
import EditUserModal from "flarum/components/EditUserModal";
import UserPage from "flarum/components/UserPage";
import Stream from "flarum/utils/Stream";

export default function () {
  extend(UserPage.prototype, 'show', function() {
    app.store.find('unilogin', this.user.id());
  });

  extend(EditUserModal.prototype, 'oninit', function() {
    this.fullname = Stream(this.attrs.user.data.attributes.fullname);
    this.unilogin = app.store.getById('unilogin', this.attrs.user.id());
    if (this.unilogin) {
      this.uniloginId = Stream(this.unilogin.data.attributes.unilogin);
      this.institutionRole = Stream(this.unilogin.data.attributes.role);
      this.institutionName = Stream(this.unilogin.data.attributes.institution_name);
      this.institutionId = Stream(this.unilogin.data.attributes.institution_id);
    }
  });

  extend(EditUserModal.prototype, 'fields', function(items) {
    items.add('user_fullname', <div className="Form-group">
      <label>{app.translator.trans('auth-unilogin.forum.edit_user.fullname')}</label>
      <input className="FormControl" bidi={this.fullname} disabled/>
    </div>, 39);

    items.add('user_unilogin', <div className="Form-group">
      <label>{app.translator.trans('auth-unilogin.forum.edit_user.unilogin_id')}</label>
      <input className="FormControl" bidi={this.uniloginId} disabled/>
    </div>, 29);

    items.add('user_role', <div className="Form-group">
      <label>{app.translator.trans('auth-unilogin.forum.edit_user.user_role')}</label>
      <input className="FormControl" bidi={this.institutionRole} disabled/>
    </div>, 28);

    items.add('institution_name', <div className="Form-group">
      <label>{app.translator.trans('auth-unilogin.forum.edit_user.institution_name')}</label>
      <input className="FormControl" bidi={this.institutionName} disabled/>
    </div>, 27);

    items.add('institution_id', <div className="Form-group">
      <label>{app.translator.trans('auth-unilogin.forum.edit_user.institution_id')}</label>
      <input className="FormControl" bidi={this.institutionId} disabled/>
    </div>, 26);
  });
}
